// Constants
import { APP_NAVIGATION_MENU, APP_ROUTES_NOT_MENU } from '@shared/constants';

// Interfaces
import { INavigationItem } from '@shared/interfaces';

// Helper method to get current navigation item
export function getCurrentNavigationItem(itemRoute: string): INavigationItem {
  let currentRoute = null;

  for (const section of APP_NAVIGATION_MENU) {
    currentRoute = section.navigationItems.find(el => el.route === itemRoute);
    if (currentRoute) break;
  }

  return currentRoute;
}

// Helper method to get navigation item from a path not present in the menu
export function getNotMenuNavigationItem(itemRoute: string): INavigationItem {
  const currentRoute = APP_ROUTES_NOT_MENU.find(el => el.route === itemRoute);
  return currentRoute;
}
